import React, { useState } from 'react';
import { Handles, Rail, Slider, Ticks, Tracks } from 'react-compound-slider';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import { IOrderDetails } from '../../../../models/order';
import {
    CancelledHandle,
    Tick,
    CancelledTrack,
} from '../../../common/slider-components';

const sliderStyle: React.CSSProperties = {
    marginTop: '15px',
    position: 'relative',
    width: '100%',
};

const railStyle: React.CSSProperties = {
    position: 'absolute',
    width: '100%',
    height: 10,
    borderRadius: 5,
    cursor: 'default',
    backgroundColor: 'lightGrey',
};

interface ICancelledPizzaTrackerProps {
    order: IOrderDetails;
}

export const CancelledPizzaTracker = ({
    order,
}: //reorder
ICancelledPizzaTrackerProps) => {
    const intl = useIntl();
    const activeTick = 1;
    const formatTicks = (d: number) => {
        if (d === 0) return '';

        return intl.formatMessage({
            id: 'Cancelled',
            defaultMessage: 'Cancelled',
        });
    };

    return (
        <>
            {order.orderStatus !== 'Scheduled' && (
                <div className="row" style={{ paddingBottom: '40px' }}>
                    <div className="col-md-12">
                        <Slider
                            mode={1}
                            step={1}
                            domain={[0, 1]}
                            disabled={true}
                            rootStyle={sliderStyle}
                            values={[1]}
                        >
                            <div>
                                <label className="control-label">
                                    <FormattedMessage id="Status" />
                                </label>
                            </div>
                            <Rail>
                                {({ getRailProps }) => (
                                    <div
                                        style={railStyle}
                                        {...getRailProps()}
                                    />
                                )}
                            </Rail>
                            <Handles>
                                {({ handles, getHandleProps }) => (
                                    <div className="slider-handles">
                                        {handles.map((handle) => (
                                            <CancelledHandle
                                                key={handle.id}
                                                handle={handle}
                                                domain={[0, 1]}
                                                getHandleProps={getHandleProps}
                                            />
                                        ))}
                                    </div>
                                )}
                            </Handles>
                            <Tracks right={false}>
                                {({ tracks, getTrackProps }) => (
                                    <div
                                        className="slider-tracks"
                                        style={{ backgroundColor: '#fff' }}
                                    >
                                        {tracks.map(
                                            ({ id, source, target }) => (
                                                <CancelledTrack
                                                    key={id}
                                                    source={source}
                                                    target={target}
                                                    getTrackProps={
                                                        getTrackProps
                                                    }
                                                />
                                            )
                                        )}
                                    </div>
                                )}
                            </Tracks>
                            <Ticks values={[0, 1]}>
                                {({ ticks }) => (
                                    <div className="slider-ticks">
                                        {ticks.map((tick) => (
                                            <Tick
                                                key={tick.id}
                                                format={formatTicks}
                                                tick={tick}
                                                count={ticks.length}
                                                activeTick={activeTick}
                                            />
                                        ))}
                                    </div>
                                )}
                            </Ticks>
                        </Slider>
                    </div>
                </div>
            )}
            <hr />
        </>
    );
};
export default CancelledPizzaTracker;
